import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'
import HttpHelper from 'Services/HttpHelper'

export const GetFeelGreatProduct = async userStatus => {
    let options = {}
    const baId = storeAuth.GetId()

    if (userStatus) {
        options.params = {
            baStatus: userStatus,
            // ordercalC asks the BE to price the publish through Hydra's order calc, and that needs a
            // real BA to calc for. A guest reaching checkout through a referral link sends the
            // referrer's status but has no id of their own, and the BE's Hydra call then 400s and comes
            // back as a 500 for the whole publish — which used to leave the page with no products at
            // all. Verified against dev: baStatus alone answers 200, ordercalC without an id never does.
            ...(baId ? { ordercalC: 1, baId } : {})
        }
    }
    const url = `${ServerEnv.MemberCalls2()}/products-v2/ufg/publish/${StoreCountry.Country3()}`

    return await HttpHelper.Get({ url, config: options })
}
